import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { login, logout, loginAdmin, loginWithPWD } from '../utils/functions/authMethod';
import { getStorage } from '../utils/functions/localstorage';

function AuthProvider({ children }) {
  const navigate = useNavigate();
  const merchantPath = getStorage('merchantPath');
  const handleSignin = async (newMobileNo, otp, ref, merchantUuid) => {
    console.log('[AuthContext] กำลังเข้าสู่ระบบ user');
    try {
      return await login(newMobileNo, otp, ref, merchantUuid);
      // window.location.reload();
    } catch (e) {
      throw new Error(e);
    }
  };

  const handleSigninWithPWD = async (payload) => {
    console.log('[AuthContext] Login With PWD');
    try {
      return await loginWithPWD(payload);
    } catch (error) {
      throw new Error(error);
    }
  }

  const handleAdminSignin = async (email, password, taxId, typeTax) => {
    console.log('[AuthContext] กำลังเข้าสู่ระบบ admin');
    try {
      const resp = await loginAdmin(email, password, taxId, typeTax);
      return resp;
    } catch (e) {
      throw e
    }
  };

  const handleSignout = async () => {
    console.log('[AuthContext] กำลังลงชื่อออก');

    await logout();

    // navigate('/login');
    navigate(`/${merchantPath}`);
  };

  const handleAdminSignout = async () => {
    console.log('[AuthContext] กำลังลงชื่อออก');

    await logout();

    navigate('/login-admin');
  };

  return (
    <PassportAuth.Provider
      value={{
        handleSignin,
        handleSigninWithPWD,
        handleAdminSignin,
        handleSignout,
        handleAdminSignout,
      }}
    >
      {children}
    </PassportAuth.Provider>
  );
}

AuthProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default AuthProvider;
export const PassportAuth = React.createContext();
